// extracted by mini-css-extract-plugin
export default {"list":"LinksView_list__uAhUc"};